import script from "./goal-type-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./goal-type-modal.vue?vue&type=script&setup=true&lang=js"

import "./goal-type-modal.vue?vue&type=style&index=0&id=23c7ff7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c7ff7f"]])

export default __exports__